"use client";

import { FC, PropsWithChildren, useMemo } from "react";

import { DirectionContext } from "@jti/fe-common";

import { DirectionConfig } from "@/app/_internal/getDirectionConfig";
import { LinkBehaviourContextProvider } from "@/context/LinkBehaviourContextProvider";
import { LocaleProvider } from "@/context/LocaleContext";
import { RewriteUrlsProvider } from "@/context/RewriteUrlsContextProvider";

type ProvidersProps = {
  lang: string;
  locale: string;
  direction: DirectionConfig;
};

const DirectionContextProvider = DirectionContext.Provider;

export const RootProviders: FC<PropsWithChildren<ProvidersProps>> = ({
  lang,
  locale,
  direction,
  children,
}) => {
  const localeProviderValue = useMemo(
    () => ({ currentLang: lang, currentLocale: locale }),
    [locale, lang]
  );

  return (
    <RewriteUrlsProvider locale={locale}>
      <LocaleProvider value={localeProviderValue}>
        <DirectionContextProvider value={direction}>
          <LinkBehaviourContextProvider>
            {children}
          </LinkBehaviourContextProvider>
        </DirectionContextProvider>
      </LocaleProvider>
    </RewriteUrlsProvider>
  );
};
